import { useCallback } from 'react';

import { captureEvent } from '@/services/analytics';

import isAiMessage from '@/features/ai-chat/lib/isAiMessage';
import isHumanMessage from '@/features/ai-chat/lib/isHumanMessage';
import type { Message } from '@/features/ai-chat/types/chat.types';
import useUserDetails from '@/hooks/useUserDetails';

export function useChatAnalytics(
  conversationId: string | null,
  messagesRef: React.RefObject<Message[]>
) {
  const { userEmail } = useUserDetails();

  return useCallback(() => {
    if (!conversationId) return;
    const humanMsg = messagesRef.current.at(-2);
    const aiMsg = messagesRef.current.at(-1);
    if (!isHumanMessage(humanMsg) || !isAiMessage(aiMsg)) return;
    captureEvent('ai_conversation', {
      timestamp: new Date().toISOString(),
      source: 'gxgo',
      conversation_id: conversationId,
      email: userEmail,
      prompt: humanMsg.text,
      response: aiMsg.content
    });
  }, [conversationId, userEmail, messagesRef]);
}
